module.exports = __webpack_public_path__ + "static/media/Add.d7dc12f1.svg";